const inflection = require( 'inflection' )
const { DataStore } = require('js-data')
const { HttpAdapter } = require('js-data-http')

module.exports = class PbxxStore extends DataStore {
  preload(name, ids = [], options = {}) {
    let missing_ids = _.reject(ids, (id) => {
      return this.get(name, id)
    })
    let query = {}
    let query_key = options.query_key || inflection.pluralize(this.getMapper(name).relations.belongs_to.foreign_key)
    query[query_key] = missing_ids
    let promise = this.findAll(name, query, {force: true})
    .then(() => {
      return _.map(ids, (id) => this.get(name, id))
    }, (error) => {
      throw(error)
    })
    return promise
  }

  configure(options) {
    let httpAdapter = new HttpAdapter({
      basePath: options.basePath,
      httpConfig: {
        headers: options.headers
      }
    })
    this.registerAdapter('http', httpAdapter, { default: true })
  }

  get http_adapter() {
    return this._adapters['http']
  }
}
